export default __webpack_public_path__ + "static/meet-john-12-d94a5287d1c5e1dd3cf30be4ff5949f0.webp";